import React, { useState } from 'react';
import { PlaneIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <>
    <h3 className="font-heading text-2xl font-bold text-navy-900 mb-6" data-id="element-70">
      Política de Privacidad
    </h3>
    <div className="font-body text-gray-700 space-y-4 text-sm leading-relaxed" data-id="element-71">
      <p data-id="element-72">
        <strong data-id="element-73">Última actualización:</strong> Marzo 2026
      </p>
      <p data-id="element-74">
        En El Protocolo de Aterrizaje, respetamos tu privacidad y nos
        comprometemos a proteger la información personal que compartes con
        nosotros.
      </p>
      <h4 className="font-heading text-lg font-semibold text-navy-900 pt-2" data-id="element-75">
        Información que recopilamos
      </h4>
      <p data-id="element-76">
        Recopilamos únicamente la información necesaria para procesar tu compra
        y entregarte el producto digital: nombre, dirección de correo
        electrónico y datos de pago. No almacenamos información de tarjetas de
        crédito en nuestros servidores.
      </p>
      <h4 className="font-heading text-lg font-semibold text-navy-900 pt-2" data-id="element-77">
        Uso de la información
      </h4>
      <p data-id="element-78">
        Tu información se utiliza exclusivamente para: procesar tu pedido,
        enviarte el producto adquirido, enviarte actualizaciones del protocolo y
        comunicaciones relacionadas con tu compra. No vendemos, alquilamos ni
        compartimos tu información personal con terceros con fines de marketing.
      </p>
      <h4 className="font-heading text-lg font-semibold text-navy-900 pt-2" data-id="element-79">
        Cookies
      </h4>
      <p data-id="element-80">
        Utilizamos cookies esenciales para el funcionamiento del sitio y cookies
        analíticas para mejorar tu experiencia. Puedes desactivar las cookies en
        la configuración de tu navegador.
      </p>
      <h4 className="font-heading text-lg font-semibold text-navy-900 pt-2" data-id="element-81">
        Seguridad
      </h4>
      <p data-id="element-82">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información personal contra acceso no autorizado, alteración
        o destrucción.
      </p>
      <h4 className="font-heading text-lg font-semibold text-navy-900 pt-2" data-id="element-83">
        Tus derechos
      </h4>
      <p data-id="element-84">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. Para ejercer estos derechos, contáctanos a través
        de los canales disponibles en nuestra plataforma.
      </p>
    </div>
  </>;
const termsContent = <>
    <h3 className="font-heading text-2xl font-bold text-navy-900 mb-6" data-id="element-85">
      Términos y Condiciones
    </h3>
    <div className="font-body text-gray-700 space-y-4 text-sm leading-relaxed" data-id="element-86">
      <p data-id="element-87">
        <strong data-id="element-88">Última actualización:</strong> Marzo 2026
      </p>
      <p data-id="element-89">
        Al adquirir El Protocolo de Aterrizaje: Misión USA 30 Días, aceptas los
        siguientes términos y condiciones.
      </p>
      <h4 className="font-heading text-lg font-semibold text-navy-900 pt-2" data-id="element-90">
        Producto digital
      </h4>
      <p data-id="element-91">
        El Protocolo de Aterrizaje es un producto digital informativo. Recibirás
        acceso inmediato al contenido tras completar tu compra. El producto
        incluye el e-book, checklists, guías y plantillas descritas en la página
        de venta.
      </p>
      <h4 className="font-heading text-lg font-semibold text-navy-900 pt-2" data-id="element-92">
        Licencia de uso
      </h4>
      <p data-id="element-93">
        Al comprar el producto, obtienes una licencia personal e intransferible
        para uso individual o familiar. Queda prohibida la reproducción,
        distribución o reventa del contenido sin autorización expresa.
      </p>
      <h4 className="font-heading text-lg font-semibold text-navy-900 pt-2" data-id="element-94">
        Actualizaciones
      </h4>
      <p data-id="element-95">
        Tu compra incluye todas las actualizaciones futuras del protocolo sin
        costo adicional. Las actualizaciones se enviarán al correo electrónico
        registrado en tu compra.
      </p>
      <h4 className="font-heading text-lg font-semibold text-navy-900 pt-2" data-id="element-96">
        Limitación de responsabilidad
      </h4>
      <p data-id="element-97">
        El contenido del protocolo es de carácter informativo y educativo. No
        constituye asesoría legal, migratoria ni financiera. Las decisiones
        tomadas con base en este material son responsabilidad exclusiva del
        comprador. Los resultados pueden variar según las circunstancias
        individuales de cada familia.
      </p>
      <h4 className="font-heading text-lg font-semibold text-navy-900 pt-2" data-id="element-98">
        Política de reembolso
      </h4>
      <p data-id="element-99">
        Debido a la naturaleza digital del producto y al acceso inmediato tras
        la compra, no se ofrecen reembolsos una vez procesado el pago. Te
        recomendamos revisar cuidadosamente la descripción del producto antes de
        realizar tu compra.
      </p>
      <h4 className="font-heading text-lg font-semibold text-navy-900 pt-2" data-id="element-100">
        Modificaciones
      </h4>
      <p data-id="element-101">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios serán efectivos desde su publicación en esta
        página.
      </p>
    </div>
  </>;
export function FooterSection() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full bg-navy-950 py-10" data-id="element-102">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-103">
          <div className="flex flex-col items-center gap-4" data-id="element-104">
            <div className="flex items-center gap-2" data-id="element-105">
              <PlaneIcon className="w-5 h-5 text-gold-500" aria-hidden="true" data-id="element-106" />
              <span className="font-heading text-lg font-bold text-white" data-id="element-107">
                El Protocolo de Aterrizaje
              </span>
            </div>

            <div className="flex items-center gap-4 font-body text-sm" data-id="element-108">
              <button onClick={() => setActiveModal('privacy')} className="text-navy-300 hover:text-gold-500 transition-colors duration-200 underline underline-offset-2" data-id="element-109">
                Política de Privacidad
              </button>
              <span className="text-navy-600" data-id="element-110">·</span>
              <button onClick={() => setActiveModal('terms')} className="text-navy-300 hover:text-gold-500 transition-colors duration-200 underline underline-offset-2" data-id="element-111">
                Términos y Condiciones
              </button>
            </div>

            <p className="font-body text-navy-300 text-sm text-center" data-id="element-112">
              © {new Date().getFullYear()} El Protocolo de Aterrizaje. Todos
              los derechos reservados.
            </p>
          </div>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-113">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-114">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-navy-950/80 backdrop-blur-sm" data-id="element-115" />

            {/* Modal content */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} onClick={e => e.stopPropagation()} className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" data-id="element-116">
              {/* Close button */}
              <div className="sticky top-0 bg-white border-b border-cream-200 px-6 py-4 flex items-center justify-between z-10" data-id="element-117">
                <span className="font-body text-xs text-gold-600 font-semibold tracking-widest uppercase" data-id="element-118">
                  {activeModal === 'privacy' ? 'Privacidad' : 'Términos'}
                </span>
                <button onClick={() => setActiveModal(null)} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-cream-100 transition-colors" aria-label="Cerrar" data-id="element-119">
                  <XIcon className="w-5 h-5 text-navy-900" data-id="element-120" />
                </button>
              </div>

              {/* Scrollable body */}
              <div className="overflow-y-auto max-h-[calc(80vh-60px)] px-6 py-6" data-id="element-121">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}